import React from 'react';
import { Box, Card, CardContent, Typography, Button, Alert, Chip } from '@mui/material';
import { Upload as UploadIcon } from '@mui/icons-material';
import { riskForecast, AI_BASE_URL } from '../../services/aiBackend';
import api from '../../services/api';

const RiskForecastPage: React.FC = () => {
  const [xerFile, setXerFile] = React.useState<File | null>(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const [response, setResponse] = React.useState<any>(null);

  const handleXerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) return;
    setXerFile(e.target.files[0]);
  };

  const runForecast = async () => {
    if (!xerFile) return;
    try {
      setLoading(true);
      setError(null);
      const res = await riskForecast(xerFile);
      setResponse(res);
      await api.post('/ai-analysis', {
        name: `Risk Forecast - ${xerFile.name}`,
        analysisType: 'risk_assessment',
        description: 'Risk forecast from AI backend',
        inputParameters: { fileName: xerFile.name },
        algorithms: { primary: 'monte_carlo' },
        dataSources: ['external_ai_backend'],
        executionSettings: { initiatedFrom: 'frontend', externalBaseUrl: AI_BASE_URL },
        results: res.data,
      });
    } catch (err: any) {
      setError(err.response?.data?.message || err.message || 'Failed to run forecast');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Risk Forecast</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>{error}</Alert>}
      <Card>
        <CardContent>
          <Typography variant="subtitle1" gutterBottom>Upload .xer file</Typography>
          <input type="file" accept=".xer" onChange={handleXerChange} />
          {xerFile && (
            <Box sx={{ mt: 2 }}>
              <Chip label={xerFile.name} variant="outlined" />
            </Box>
          )}
          <Button variant="contained" startIcon={<UploadIcon />} disabled={loading} onClick={runForecast}>
            Run Forecast
          </Button>
          {response && (
            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle2">Response Status: {response.status}</Typography>
              <pre style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(response.data, null, 2)}</pre>
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default RiskForecastPage;